"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  fillOpacity: ".3",
  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9zm-3.45-3.35h2.3L12 9z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m11 7-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7zm-.15 5.65L12 9l1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12z"
}, "1")], 'BrightnessAutoTwoTone');